<template>
	<div class="positions--wrapper">
		<Hero />
		<section class="section-positions-list" id="jobs">
			<div class="container job-listing-wrapper">
				<header>
					<h2 class="heading heading--xl text-uppercase">
						JOB LISTINGS
					</h2>
				</header>
				<Jobs paginated theme="blue" />
			</div>
		</section>
		<section class="section-resting"></section>
		<section class="section-featured-roles">
			<ContainerWithOffset :offset="280">
				<div class="inner">
					<header class="section-header">
						<h2 class="heading heading--md text-uppercase">
							VIEW MORE JOBS
						</h2>
						<p class="paragraph">
							Can’t find what you’re looking for? We have Open
							Applications and Internships too!
						</p>
					</header>
				</div>
				<job-tiles></job-tiles>
			</ContainerWithOffset>
		</section>
	</div>
</template>

<script>
import Jobs from "../components/jobs/Jobs";
import JobsPositionsSlider from "../components/sliders/JobsPositionsSlider";
import FullWidthSlider from "../components/sliders/FullWidthSlider";
import Spinner from "../components/common/Spinner";
import BasicButton from "../components/BasicButton";
import Hero from "../components/openPositions/Hero";
import ContainerWithOffset from "../components/common/ContainerWithOffset";
import JobTiles from "../components/JobTiles";

export default {
	name: "PositionsPage",
	components: {
		JobTiles,
		Jobs,
		JobsPositionsSlider,
		FullWidthSlider,
		Spinner,
		BasicButton,
		Hero,
		ContainerWithOffset
	},
	mounted() {
		if (this.$route.fullPath.includes("#jobs")) {
			this.$scrollTo("#jobs", 1000, {});
		}
	},
	metaInfo() {
		return {
			title: "Job openings",
			htmlAttrs: {
				lang: "en",
				metaInfo: {
					meta: [
						{ charset: "utf-8" },
						{ name: "og:title", content: "Job Position page" },
						{
							name: "description",
							content: "Bohemia Interactive position page"
						}
					]
				}
			}
		};
	}
};
</script>

<style lang="scss" type="text/scss">
@import "../assets/scss/globals";

.job-listing-wrapper {
	padding-left: 30px;
	padding-right: 30px;
}

.positions--wrapper {
	@media (max-width: $tablet) {
	}
}

.section-positions-list {
	padding-top: 125px;
	padding-bottom: 120px;

	@media (max-width: $mq-sm-max) {
		padding-top: 60px;
		padding-bottom: 60px;
	}

	header {
		padding-bottom: 100px;

		@media (max-width: $mq-md-max) {
			padding-bottom: 40px;
		}
		.heading {
			color: $text-strong;
		}

		.paragraph {
			width: 50%;
			margin-top: 20px;
			line-height: 1.75;

			@media (max-width: $mq-sm-max) {
				width: auto;
			}
		}
	}
}

header.section-header {
	padding-bottom: 26px;

	.heading {
		color: $text-strong;
	}

	.paragraph {
		font-size: 18px;
		width: 51%;
		margin-top: 20px;
		line-height: 1.55;

		@media (max-width: $mq-sm-max) {
			width: auto;
		}
	}
}

.section-resting {
	background: url("/static/img/backgrounds/parallax_resting_bckg.jpg") center
		no-repeat;
	background-size: cover;
	position: relative;
	height: 60vh;
	background-attachment: fixed;
	@media (max-width: $tablet) {
		height: 40vh;
	}

	@media (max-width: $compact) {
		background: url("/static/img/job_openings/resting_image_jobsapp.png");
		background-attachment: scroll;
		background-size: cover;
		//background-size: 100% 100%;
	}
}

.section-featured-roles {
	background-color: white;
	margin-top: 10em;
	@media (max-width: $mq-md-max) {
		margin-top: 0;
	}
	header {
	}
}

.inner {
	padding-top: 75px;
	padding-left: 35px;
	padding-right: 35px;
}
</style>



// WEBPACK FOOTER //
// src/pages/PositionsList.vue